import { Component } from '@angular/core';

import { UserUnlockService } from '@login/services/user-unlock.service';
import { SpinnerService } from '@shared/services/spinner.service';
import { AlertService } from '@shared/services/alert.service';

@Component({
  selector: 'app-challenge-question-unlock',
  templateUrl: './challenge-question-unlock.component.html',
  styleUrls: ['./challenge-question-unlock.component.scss'],
})
export class ChallengeQuestionUnlockComponent {
  isValidRecoveryToken = true;
  alertMessage: string;
  isUnlockSuccessful = false;

  constructor(
    private userUnlockService: UserUnlockService,
    private spinnerService: SpinnerService,
    private alertService: AlertService,
  ) {}

  onVerifyRecoveryAnswerSuccess() {
    this.alertService.clearAlert();
    this.spinnerService.stop();
    this.isUnlockSuccessful = true;
  }

  onVerifyRecoveryAnswerError(err) {
    const errorMessage = this.getErrorMessage(err);
    this.alertService.setAlert(errorMessage);
    this.spinnerService.stop();
  }

  onIsValidRecoveryToken({ isValid, err }) {
    this.alertService.clearAlert();
    this.isValidRecoveryToken = isValid;
    this.alertMessage = this.getErrorMessage(err);
  }

  private getErrorMessage(err) {
    return (
      err?.error?.errorMessage || err?.error?.statusText || err?.statusText
    );
  }
}
